import styled from "styled-components";
import { media } from "../../Styles/utils";
import { Colors as colors, Dark } from "../../utils/Colors";
export const AiCaseStudies = styled.div`
background:${(props)=> props.theme==true? Dark.AICaseColor:colors.AICaseColor};
margin-top:80px;
${media("medium")}{
    margin-top:80px;
}`;
